/*
 * Live "who is online" panels.
 *
 * The server broadcasts on a public channel whenever somebody arrives or leaves. The
 * broadcast carries headcounts and nothing else; every panel that hears it asks its own
 * Livewire component to redraw, which is where names, avatars and who is allowed to see
 * what any of them are doing get decided.
 *
 * The panels keep their slow poll as well. A visitor who closes the tab sends no goodbye
 * and simply times out of the sorted set, which produces no event, so something has to
 * notice eventually.
 */

/* Arrivals cluster, and every panel on the page reacts to each one. */
const REFRESH_THROTTLE = 5000;

document.addEventListener('alpine:init', () => {

	Alpine.data('sitePresence', () => {

		/*
		 * Held in the closure rather than on the returned object. Anything on that object
		 * becomes part of Alpine's reactive data and is wrapped in a proxy, and calling a
		 * native method through such a proxy fails with "Illegal invocation".
		 */
		let subscribed = false;

		return {

			lastRefresh: 0,
			refreshQueued: false,

			init() {

				if (! window.Echo) {
					return;
				}

				window.Echo.channel('presence.site')
					.listen('.presence.changed', () => this.refresh());

				subscribed = true;

				document.addEventListener('livewire:navigating', () => this.destroy(), { once: true });
			},

			destroy() {

				if (subscribed && window.Echo) {
					window.Echo.leaveChannel('presence.site');
					subscribed = false;
				}
			},

			refresh() {

				const now = Date.now();
				const since = now - this.lastRefresh;

				if (since >= REFRESH_THROTTLE) {
					this.lastRefresh = now;
					this.$wire && this.$wire.$refresh();

					return;
				}

				if (this.refreshQueued) {
					return;
				}

				this.refreshQueued = true;

				setTimeout(() => {
					this.refreshQueued = false;
					this.lastRefresh = Date.now();
					this.$wire && this.$wire.$refresh();
				}, REFRESH_THROTTLE - since);
			},

		};

	});

});
